// `next` do login: só caminho interno do painel. O destino vira navegação logo depois do
// login, então qualquer coisa que o navegador possa ler como outro host é recusada.
//
// O navegador REMOVE tab e quebra de linha de uma URL antes de interpretar (`/\t/evil.com`
// vira `//evil.com`) e trata `\` como `/`. Por isso a regra é sobre a string e também sobre
// a versão decodificada: sem caractere de controle, espaço ou barra invertida em lugar nenhum,
// uma única `/` no começo e nunca `//`.

import { z } from 'zod';

// biome-ignore lint/suspicious/noControlCharactersInRegex: é exatamente o que se recusa
const FORBIDDEN = /[\u0000-\u0020\u007f-\u009f\\]/;

function internalPath(value: string): boolean {
  return !FORBIDDEN.test(value) && /^\/(?!\/)/.test(value);
}

export function isSafeNextPath(value: string): boolean {
  if (!internalPath(value)) {
    return false;
  }
  try {
    return internalPath(decodeURIComponent(value));
  } catch {
    return false;
  }
}

/** Valor inválido some (`undefined`) em vez de derrubar a tela de login. */
export const nextPathSchema = z.string().refine(isSafeNextPath).optional().catch(undefined);
